/* ========================================
   THE SCENT VAULT — Theme JS
   ======================================== */

(function() {
  'use strict';

  /* ── Scroll Reveal ──────────────────── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.reveal, .reveal-scale');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── Header scroll effect ───────────── */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ── Mobile Nav ─────────────────────── */
  function initMobileNav() {
    var toggle = document.querySelector('.menu-toggle');
    var nav = document.querySelector('.mobile-nav');
    var closeBtn = document.querySelector('.mobile-nav-close');
    if (!toggle || !nav) return;

    function openNav() {
      nav.classList.add('active');
      toggle.classList.add('active');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      nav.classList.remove('active');
      toggle.classList.remove('active');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function() {
      if (nav.classList.contains('active')) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeNav);
    }

    nav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', closeNav);
    });
  }

  /* ── Cart Drawer ────────────────────── */
  function initCartDrawer() {
    var overlay = document.querySelector('.cart-overlay');
    var drawer = document.querySelector('.cart-drawer');
    var openBtns = document.querySelectorAll('[data-cart-open]');
    var closeBtns = document.querySelectorAll('[data-cart-close]');

    function openCart() {
      if (overlay) overlay.classList.add('active');
      if (drawer) drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      if (overlay) overlay.classList.remove('active');
      if (drawer) drawer.classList.remove('active');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', openCart); });
    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeCart); });
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  /* ── Product Page: Size Selector (event delegation) ────── */
  function initSizeSelector() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.size-btn');
      if (!btn) return;
      // Don't process if inside a product-card (those are size chips, not the product page selector)
      if (btn.closest('.product-card')) return;

      var isAvailable = btn.getAttribute('data-available') === 'true';
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var addBtn = document.getElementById('add-to-vault-btn');
      var stockIndicator = document.getElementById('stock-indicator');
      var soldOutNotice = document.getElementById('sold-out-notice');
      var lowStockAlert = document.getElementById('low-stock-alert');
      var stockQtyEl = document.getElementById('stock-qty');
      var stickyPrice = document.getElementById('sticky-price');
      var stickyBtn = document.getElementById('sticky-atc-btn');

      var addText = addBtn ? (addBtn.getAttribute('data-add-text') || 'Add to Vault') : '';
      var soldText = addBtn ? (addBtn.getAttribute('data-sold-text') || 'Sold Out') : '';
      var inventory = window.variantInventory || {};

      // Update active state
      document.querySelectorAll('.size-options .size-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');

      // Update price
      var price = btn.getAttribute('data-price');
      var priceEl = document.getElementById('ProductPrice') || document.querySelector('.product-price');
      var variantInput = document.getElementById('variant-id');

      if (priceEl && price) priceEl.textContent = price;
      if (variantInput && variantId) variantInput.value = variantId;
      if (stickyPrice && price) stickyPrice.textContent = price;

      // Update add to cart buttons
      if (addBtn) {
        addBtn.disabled = !isAvailable;
        addBtn.textContent = isAvailable ? addText : soldText;
      }
      if (stickyBtn) {
        stickyBtn.textContent = isAvailable ? addText : soldText;
        stickyBtn.style.opacity = isAvailable ? '1' : '0.4';
        stickyBtn.style.pointerEvents = isAvailable ? 'auto' : 'none';
      }
      if (soldOutNotice) soldOutNotice.style.display = isAvailable ? 'none' : 'block';
      if (stockIndicator) {
        if (isAvailable) {
          stockIndicator.classList.remove('out');
        } else {
          stockIndicator.classList.add('out');
        }
      }

      // Update low stock alert
      var variantData = inventory[variantId];
      if (lowStockAlert && variantData) {
        if (variantData.managed && variantData.available && variantData.inventory > 0 && variantData.inventory <= 10) {
          lowStockAlert.style.display = 'flex';
          if (stockQtyEl) stockQtyEl.textContent = variantData.inventory;
        } else {
          lowStockAlert.style.display = 'none';
        }
      } else if (lowStockAlert && !isAvailable) {
        lowStockAlert.style.display = 'none';
      }
    });
  }

  /* ── Sticky Mobile Add to Cart Bar ──── */
  function initStickyATC() {
    var showThreshold = 0;

    function getThreshold() {
      var addBtn = document.getElementById('add-to-vault-btn');
      if (!addBtn) return 0;
      var rect = addBtn.getBoundingClientRect();
      return rect.bottom + window.scrollY;
    }

    function onScroll() {
      var stickyBar = document.getElementById('sticky-atc');
      if (!stickyBar) return;
      if (!showThreshold) showThreshold = getThreshold();
      if (!showThreshold) return;

      if (window.scrollY > showThreshold) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() { showThreshold = getThreshold(); }, { passive: true });
  }

  /* ── Accordion (event delegation) ──── */
  function initAccordion() {
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.accordion-trigger');
      if (!trigger) return;

      var item = trigger.closest('.accordion-item');
      if (!item) return;
      var content = item.querySelector('.accordion-content');
      var inner = content.querySelector('.accordion-content-inner');

      if (item.classList.contains('open')) {
        content.style.maxHeight = '0';
        item.classList.remove('open');
      } else {
        content.style.maxHeight = inner.scrollHeight + 'px';
        item.classList.add('open');
      }
    });
  }

  /* ── Product Card Size Chips (event delegation) ── */
  function initSizeChips() {
    document.addEventListener('click', function(e) {
      var chip = e.target.closest('.size-chip');
      if (!chip) return;

      var card = chip.closest('.product-card');
      if (!card) return;

      e.preventDefault();
      e.stopPropagation();

      card.querySelectorAll('.size-chip').forEach(function(c) { c.classList.remove('active'); });
      chip.classList.add('active');

      var priceEl = card.querySelector('.price-current');
      if (priceEl) {
        priceEl.textContent = chip.getAttribute('data-price') || priceEl.textContent;
      }
    });
  }

  /* ── Product Image Gallery (event delegation) ── */
  function initProductGallery() {
    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('.product-thumbnail');
      if (!thumb) return;

      var mainImg = document.querySelector('.product-main-image img');
      if (!mainImg) return;

      document.querySelectorAll('.product-thumbnail').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');

      var img = thumb.querySelector('img');
      if (img) {
        var src = img.getAttribute('data-full-src') || img.src;
        mainImg.src = src;
      }
    });
  }

  /* ── Init ────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initHeaderScroll();
    initMobileNav();
    initCartDrawer();
    initSizeSelector();
    initStickyATC();
    initAccordion();
    initSizeChips();
    initProductGallery();
  });

})();
